// extracted by mini-css-extract-plugin
module.exports = {"action_toOH-b":"action_toOH-b","menu-item_3jVytx":"menu-item_3jVytx"};